import { Flex } from '@blockanalitica/ui';
import TotalAssetsHistoricGraph from './TotalAssetsHistoricGraph';

export default function HistoricTabs() {
  return (
    <Flex flexDirection="column" gap="xs">
      <TotalAssetsHistoricGraph />
    </Flex>
  );
}
